/*
 * Copyright (c) 2025, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createTheme } from '@mui/material/styles';

// Devant theme colors
export const devantColors = {
  primary: {
    main: '#2F5FA7',
    light: '#5F89D4',
    dark: '#204377',
  },
  secondary: {
    main: '#6b7085',
    light: '#eceff4',
    dark: '#2e313f',
  },
  background: {
    default: '#EBEFF5',
    paper: '#ffffff',
  },
  text: {
    primary: '#212121',
    secondary: '#6b7085',
  },
};

const theme = createTheme({
  palette: {
    primary: devantColors.primary,
    secondary: devantColors.secondary,
    background: devantColors.background,
    text: devantColors.text,
  },
  typography: {
    fontFamily: [
      'Gilmer',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h4: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;
